import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { InputKit } from '../../components/UI';
import { AuthService } from '../../Service/AuthService';
import { useAppDispatch } from '../../store/hooks';
import { createNotification } from '../../store/notifications/notification-slice';
export interface IFormInput {
  email: string;
}

const ForgotPassword = () => {
  const [reseted, setReseted] = useState(false);
  const methods = useForm<IFormInput>();
  const { handleSubmit, watch } = methods;
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();

  const resetPassword = async (values: IFormInput) => {
    try {
      const response = await AuthService.forgotPassword(values.email);

      setReseted(true);
    } catch (error) {
      appDispatch(
        createNotification({
          message: 'Something went wrong!',
          type: 'error',
        })
      );
    }
  };

  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          maxWidth: '100%',
          width: '100%',
          display: 'flex',
          padding: '20px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <form
          action=''
          style={{
            maxWidth: '472px',
            width: '100%',
          }}
        >
          <Box
            bgcolor={'#fff'}
            display={'flex'}
            flexDirection={'column'}
            p={'24px'}
            sx={{ boxShadow: '0px 2px 20px  rgba(29, 49, 55, 0.12)' }}
            borderRadius={'4px'}
            gap={'24px'}
          >
            <Typography variant='h1'>Reset your password</Typography>
            {!reseted ? (
              <>
                <Typography
                  color={'#736977'}
                  fontSize={'14px'}
                  fontWeight={'500'}
                  lineHeight={'17px'}
                >
                  Enter the email address associated with your account, and
                  we’ll send you a link to reset your password
                </Typography>
                <InputKit
                  name={'email'}
                  placeholder='Email'
                  // disabled={true}
                  type='email'
                  validation={{
                    required: {
                      value: true,
                      message: 'Email is required',
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address',
                    },
                  }}
                />
                <Button
                  sx={{
                    background: '#3293DB',
                    color: '#fff',
                    maxWidth: '100%',
                    boxShadow: 'unset',
                    fontSize: '14px',
                    lineHeight: '17px',
                  }}
                  onClick={handleSubmit(resetPassword)}
                  type='submit'
                  variant='contained'
                >
                  Reset password
                </Button>
                <Button
                  sx={{
                    maxWidth: '100%',
                    boxShadow: 'unset',
                    fontSize: '14px',
                    lineHeight: '17px',
                  }}
                  onClick={() => navigate('/')}
                  variant='text'
                >
                  Return to Log in
                </Button>
              </>
            ) : (
              <>
                <Typography
                  color={'#736977'}
                  fontSize={'14px'}
                  fontWeight={'500'}
                  lineHeight={'17px'}
                >
                  An email with the instructions to reset your password has been
                  sent to{' '}
                  <span style={{ color: '#3293DB' }}>{watch('email')}</span>
                </Typography>
                <Typography
                  color={'#736977'}
                  fontSize={'14px'}
                  fontWeight={'500'}
                  lineHeight={'17px'}
                >
                  Please check your inbox and follow the instructions.
                </Typography>
                <Button
                  sx={{
                    background: '#3293DB',
                    color: '#fff',
                    maxWidth: '100%',
                    boxShadow: 'unset',
                    fontSize: '14px',
                    lineHeight: '17px',
                  }}
                  onClick={() => navigate('/')}
                  type='submit'
                  variant='contained'
                >
                  Return to Log in
                </Button>
              </>
            )}
          </Box>
        </form>
      </Box>
    </FormProvider>
  );
};

export default ForgotPassword;
